import Amex from "assets/images/card-types/amex.png";
import Discover from "assets/images/card-types/discover.png";
import Master from "assets/images/card-types/master.png";
import Visa from "assets/images/card-types/visa.png";

export const renderCardType = (type) => {
  switch (type) {
    case "Visa":
      return <img src={Visa} alt="network" className="network-image" />;
    case "Discover":
      return <img src={Discover} alt="network" className="network-image" />;
    case "American_express":
      return <img src={Amex} alt="network" className="network-image" />;
    case "Master":
      return <img src={Master} alt="network" className="network-image" />;

    default:
      return <img src={Visa} alt="network" className="network-image" />;
  }
};
